import { Routes, Route } from "react-router-dom";
import NotFound from "../Components/NotFound";
import UsersShow from "../Components/AdminPages/UsersShow";
import ProductsShow from "../Components/AdminPages/ProductsShow";
import ProductsAdd from "../Components/AdminPages/ProductsAdd";
import ProductsUpdate from "../Components/AdminPages/ProductsUpdate";
import AdminCreate from "../Components/AdminPages/AdminCreate";
import Dashboard from "../Components/AdminPages/Dashboard";

export const AdminRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<Dashboard />}/>
        <Route path="/admin/users/show" element={<UsersShow />} />
        <Route path="/admin/products/show" element={<ProductsShow />}/>
        <Route path="/admin/products/add" element={<ProductsAdd />}/>
        <Route path="/admin/products/edit" element={<ProductsUpdate />} />
        <Route path="/admin/createAdmin" element={<AdminCreate />} />
        <Route path='*' element={<NotFound />}/>
    </Routes>
  );
};
